"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_amplify_1 = require("aws-amplify");
const rxjs_1 = require("rxjs");
const react_1 = require("react");
let subscription;
let success;
let failure;
exports.cognitoConfig = (onSuccess, onFailure) => {
    success = onSuccess ? onSuccess : () => { };
    failure = onFailure ? onFailure : () => { };
};
const REFRESH_LIMIT = 25 * 60 * 1000;
exports.login = (username, password) => {
    return aws_amplify_1.Auth.signIn(username, password).then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED')
            return aws_amplify_1.Auth.completeNewPassword(user, password, null);
        return Promise.resolve(user);
    }).then(() => {
        setTimeout(() => handleRefresh(), REFRESH_LIMIT);
        return exports.getUserData().then((_a) => {
            var { accessToken } = _a, user = __rest(_a, ["accessToken"]);
            return Promise.resolve(user);
        });
    }).catch(err => {
        handleError(err, "Unable to log in");
        Promise.resolve(false);
    });
};
exports.signIn = (username, password) => {
    return aws_amplify_1.Auth.signIn(username, password).then((user) => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            return aws_amplify_1.Auth.completeNewPassword(user, password, null);
        }
        return Promise.resolve(user);
    }).then(() => {
        setTimeout(() => handleRefresh(), 25 * 60 * 1000);
        return exports.getUserData().then((_a) => {
            var { accessToken } = _a, user = __rest(_a, ["accessToken"]);
            success(user);
            return Promise.resolve(true);
        });
    }).catch((err) => {
        handleError(err, "Unable to log in");
        Promise.resolve(false);
    });
};
exports.refresh = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        console.log('refreshing session', new Date());
        const cognitoUser = yield aws_amplify_1.Auth.currentAuthenticatedUser();
        const currentSession = yield aws_amplify_1.Auth.currentSession();
        const refreshToken = yield currentSession.getRefreshToken();
        cognitoUser.refreshSession(refreshToken, (err, session) => {
            console.log('session', err, session);
            if (err) {
                handleError(err); // TODO: perhaps retry
                return Promise.reject(err);
            }
            setTimeout(() => handleRefresh(), 25 * 60 * 1000);
            return exports.getUserData().then((_a) => {
                var { accessToken } = _a, user = __rest(_a, ["accessToken"]);
                success(user);
                return Promise.resolve(true);
            });
        });
    }
    catch (e) {
        handleError(e); // TODO: perhaps retry
        return Promise.reject(e);
    }
});
exports.getUserData = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const cognitoUser = yield aws_amplify_1.Auth.currentAuthenticatedUser();
        const currentSession = yield aws_amplify_1.Auth.currentSession();
        const accessToken = yield currentSession.getAccessToken();
        const username = cognitoUser.username;
        const permissions = cognitoUser.attributes['custom:permissions'] || '';
        const user = { username, accessToken, inSession: true, permissions };
        return Promise.resolve(user);
    }
    catch (e) {
        handleError(e); // TODO: perhaps retry
        return Promise.reject(e);
    }
});
exports.forgotPassword = (username) => {
    return aws_amplify_1.Auth.forgotPassword(username);
};
exports.forgotPasswordSubmit = (username, code, new_password) => {
    return aws_amplify_1.Auth.forgotPasswordSubmit(username, code, new_password);
};
exports.changePassword = (oldPassword, newPassword) => {
    return aws_amplify_1.Auth.currentAuthenticatedUser()
        .then((user) => {
        return aws_amplify_1.Auth.changePassword(user, oldPassword, newPassword);
    });
};
exports.checkPassword = (password) => {
    return exports.getUserData().then(({ username }) => {
        return aws_amplify_1.Auth.signIn(username, password);
    });
};
const handleRefresh = () => {
    console.log('handling refresh');
    if (subscription != null) {
        console.log('unsubscribing');
        subscription.unsubscribe();
    }
    subscription = rxjs_1.interval(25 * 60 * 1000).subscribe(() => exports.refresh());
    console.log('subscription:', subscription);
};
const handleError = (error, title) => {
    const message = (error && error.message) ? error.message : (error ? error : 'An unknown error occurred. Please check your internet connection.');
    console.log('Auth error: ', message, title);
    failure(message, title);
    exports.logout();
};
exports.logout = () => {
    try {
        subscription.unsubscribe();
    }
    catch (ex) { }
    return aws_amplify_1.Auth.signOut();
};
exports.useSession = (options = {}) => {
    const [state, setState] = react_1.useState({
        user: null,
        error: null,
        loading: false
    });
    const { onError, onCompleted } = options;
    const handleSignIn = (username, password) => __awaiter(void 0, void 0, void 0, function* () {
        setState(Object.assign(Object.assign({}, state), { loading: true }));
        return exports.login(username, password).then((result) => {
            setState(Object.assign(Object.assign({}, state), { loading: false, user: result }));
            if (onCompleted)
                onCompleted(result);
            return Promise.resolve(result);
        }).catch((e) => {
            setState(Object.assign(Object.assign({}, state), { loading: false, error: e }));
            if (onError)
                onError(e);
            else
                handleError(e);
            return Promise.resolve(e);
        });
    });
    return [
        handleSignIn,
        state
    ];
};
//# sourceMappingURL=cognito.js.map